export default __webpack_public_path__ + "static/media/WF2.d2b70d99.png";